import React, { useState,useContext } from 'react';
import ThemeToggleButton from '../ThemeToggleButton/ThemeToggleButton';

import { Link } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import ThemeContext from '../../context/ThemeContext';

import './Header.css';



const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { theme } = useContext(ThemeContext);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <header className={`header ${theme}`}>
     <Link className={`link ${theme}`} to="/"><img 
    src={theme === 'dark' ? '/assets/gif/Atefe.gif' : '/assets/gif/Atefe2.gif'} 
    alt="Logo" 
    className="header-logo" 
  /></Link>

      <nav className={`navbar ${theme}`}>
        <ul>
          <li><Link className={`link ${theme}`} to="/">Work</Link></li>
          <li><Link className={`link ${theme}`} to="/about">About</Link></li>
        </ul>
      </nav>
      <ThemeToggleButton/>

      {/* Hamburger Menu Button (Visible on smaller screens) */}
      <button className={`hamburger ${theme}`} onClick={toggleSidebar}>
        &#9776;
      </button>
      {/* Sidebar (shows when hamburger is clicked) */}
      {isSidebarOpen && <Sidebar toggleSidebar={toggleSidebar} />}
    </header>
  );
};

export default Header;
